import { DomainObject } from 'types';
import { ApiRoute, PageKey } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';

import { EadActionButtons } from './ead-action-buttons';

export const eadConfig: GridEntityConfig<never, DomainObject> = {
  id: 'ead',
  title: 'Ead',
  getLabel: (item) => item.title ?? '',
  getId: (item) => item.id,
  apiRoute: ApiRoute.EAD,
  listApi: '',
  pageKey: PageKey.EAD,
  ActionButtons: EadActionButtons,
  icon: 'description',
  bodyComponents: {},
};

export const eadGridConfig: any[] = [eadConfig];
